function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.293 30.567L49.999 12.5 18.625 30.612l-1.098.639v37.5L46.512 85.48l2.158 1.245 1.329.775 1.169-.686 2.324-1.335 28.98-16.729v-37.5l-1.179-.683zM48.67 83.845l-28.645-16.54V34.309L48.67 50.847v32.998zm1.249-35.159L21.123 32.06l28.876-16.672 28.798 16.626-28.878 16.672z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.97 50.298c-1.662-2.99-4.833-4.396-7.093-3.146-2.261 1.25-2.749 4.689-1.092 7.68a8.173 8.173 0 0 0 1.568 1.989l-1.948 10.543 6.791 4.369-1.214-13.307a3.786 3.786 0 0 0 1.896-.447c2.254-1.249 2.747-4.69 1.092-7.681z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 48,
    width: 48,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.89da48a7.svg";
export { ForwardRef as ReactComponent };